/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ModalWindow } from '../../../modal';
import { useClickController } from '../../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент подсказки в виде модального окна
 *
 * @export
 * @param {ITooltipMobileProps} props
 * @returns
 */
export function TooltipMobile(props) {
  var title = props.title,
    header = props.header,
    children = props.children;
  var _useClickController = useClickController(props),
    childrenProps = _useClickController.childrenProps,
    open = _useClickController.open,
    handleClose = _useClickController.handleClose;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/_jsx(ModalWindow, {
      open: open,
      onClose: handleClose,
      title: header,
      content: title
    })]
  });
}